/**
 * ResponsavelCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

@HttpExclude()
export class ResponsavelCollection extends PageCollection<Responsavel> {
  constructor() {
    super(Responsavel)
  }

  queryAsPage() {
    return this.listResponsavel()
  }

  async listResponsavel() {
    return await Request.get(`/admin/responsavel`, {params: this.params})
      .name('listResponsavel')
      .as(this)
      .getResponse()
  }

  async listErroIntegracaoResponsavel() {
    return await Request.get(`/admin/erro-integracao/responsavel`, {
      params: this.params,
    })
      .name('listErroIntegracaoResponsavel')
      .as(this)
      .getData()
  }

  async listCsvResponsavel() {
    return await Request.get(`/admin/responsavel/csv`, {params: this.params})
      .name('listCsvResponsavel')
      .as(this)
      .getResponse()
  }
}
